import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MetalTypeForm from '../../../../components/masters/metalPurity/metaltype/MetalTypeForm';
import MetalTypeTable from '../../../../components/masters/metalPurity/metaltype/MetalTypeTable';
import { fetchMetalTypes, addMetalType, updateMetalType, deleteMetalType, setMetalTypeEdit, clearMetalTypeEdit } from '../../../../redux/actions/masters/metalPurity/metaltype/metalTypeAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .metal-type-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .metal-type-form, .metal-type-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const MetalTypePage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingMetalType, formSuccess, formError } = useSelector(state => state.metalType || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchMetalTypes());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearMetalTypeEdit());
  };

  const handleSubmit = async (form) => {
    if (editingMetalType && editingMetalType.metal_type_id) {
      await dispatch(updateMetalType(editingMetalType.metal_type_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addMetalType(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (metalType) => {
    dispatch(setMetalTypeEdit(metalType));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteMetalType(id));
  };

  const handleCancel = () => {
    dispatch(clearMetalTypeEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      mt => mt.metal_type_code === code && (!excludeId || mt.metal_type_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="metal-type-flex">
        <div style={tableContainer} className="metal-type-table">
          <MetalTypeTable
            onNew={handleFormReset}
            metalTypes={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="metal-type-form">
          <MetalTypeForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingMetalType={editingMetalType}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default MetalTypePage; 